<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <site-modal
    ID="deleteConfirmation"
    modalSize="semiMedium"
    :modalHasFooter="false"
    @Closed="closedDeleteConfirmation"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="16px"
            height="16px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path
              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            ></path>
          </svg>
          لغو جلسه
        </h6>
      </div>
    </template>
    <template #body>
      <div
        v-if="modalError.length != 0"
        class="text-danger bg-danger-soft p-2 rounded"
      >
        <p v-for="(item, index) in modalError" :key="index">• {{ item }}</p>
      </div>
      <div>
        <p class="mb-2" style="text-align: justify">
          آیا از لغو جلسه خود اطمینان دارید؟
        </p>
        <hr class="m-2" />
      </div>
      <div class="mt-4 d-flex justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="confirmDeleteInvoice"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="closedDeleteConfirmation"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal>
  <site-modal
    ID="paySessionsModal"
    modalSize="semiMedium"
    :modalHasFooter="false"
    @Closed="closedPaySessionsModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6 v-if="!goTosessionsListSuccessfully">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-all"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"
            ></path>
          </svg>
          ثبت جلسات
        </h6>
        <h6 v-else>
          <i class="fi mdi-check"></i>
          ثبت موفق
        </h6>
      </div>
    </template>
    <template #body>
      <div v-if="!goTosessionsListSuccessfully">
        <div>
          <validation-summery
            v-if="checkoutInvoiceHasError"
            :errors="checkoutInvoiceModalError"
          ></validation-summery>
          <!-- 
            " -->
          <p
            v-if="
              !selectedInvoiceList.invoiceItems.some((s) => !s.isCancelable)
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-exclamation-triangle-fill text-warning"
              viewBox="0 0 16 16"
            >
              <path
                d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
              />
            </svg>
            توجه داشته باشید، فقط تا
            <b> 48 ساعت قبل از شروع جلسه</b> امکان لغو یا جابجایی
            <b>وجود دارد</b>.
          </p>
          <p v-else>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-exclamation-triangle-fill text-warning"
              viewBox="0 0 16 16"
            >
              <path
                d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
              />
            </svg>
            توجه داشته باشید جلسات قابلیت
            <b>لغو یا جابجایی</b>
            ندارند.
          </p>
          <p class="mb-2" style="text-align: justify">
            صورت وضعیت جلسات شما به شرح زیر است:
          </p>
          <check-box-with-message
            title="از موجودی کیف پول استفاده شود"
            color="#506690"
            :disabled="selectedInvoiceList.walletBalance == 0"
            container-class="pb-2"
            v-model:checkBoxValue="useWallet"
            v-if="selectedInvoiceList.currencyTypeID == 1"
          />
          <div class="row" style="clear: both">
            <div class="col-8">
              <b :class="isMobile ? 'fs-7' : ''">مبلغ کل جلسات:</b>
            </div>
            <div class="col-4" :class="isMobile ? 'fs-7' : ''">
              {{
                this.thousandSeprator(
                  selectedInvoiceList.totalAmount,
                  ',',
                  '.'
                ) +
                ' ' +
                selectedInvoiceList.currencyName
              }}
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <b :class="isMobile ? 'fs-7' : ''">موجودی کیف پول:</b>
            </div>
            <div
              class="col-4"
              :class="selectedInvoiceList.totalAmount > 0 ? 'text-success' : ''"
            >
              <span :class="isMobile ? 'fs-7' : ''">
                {{
                  thousandSeprator(
                    selectedInvoiceList.walletBalance,
                    ',',
                    '.'
                  ) +
                  ' ' +
                  selectedInvoiceList.currencyName
                }}
              </span>
            </div>
          </div>
          <hr class="m-2" />
          <div class="row">
            <div class="col-8">
              <b :class="isMobile ? 'fs-7' : ''">مبلغ قابل پرداخت:</b>
            </div>
            <div class="col-4 text-danger" :class="isMobile ? 'fs-7' : ''">
              <template v-if="useWallet">
                {{
                  selectedInvoiceList.walletBalance -
                    selectedInvoiceList.totalAmount >
                  0
                    ? '0'
                    : thousandSeprator(
                        Math.abs(
                          selectedInvoiceList.walletBalance -
                            selectedInvoiceList.totalAmount
                        ),
                        ',',
                        '.'
                      )
                }}
                {{ selectedInvoiceList.currencyName }}
              </template>
              <template v-else>
                {{
                  thousandSeprator(selectedInvoiceList.totalAmount, ',', '.')
                }}
                {{ selectedInvoiceList.currencyName }}
              </template>
            </div>
            <div class="col-8" v-if="useWallet">
              <b :class="isMobile ? 'fs-7' : ''"
                >موجودی کیف پول پس از کسر مبلغ:</b
              >
            </div>
            <div
              class="col-4 text-danger"
              v-if="useWallet"
              :class="isMobile ? 'fs-7' : ''"
            >
              {{
                selectedInvoiceList.walletBalance -
                  selectedInvoiceList.totalAmount >
                0
                  ? thousandSeprator(
                      selectedInvoiceList.walletBalance -
                        selectedInvoiceList.totalAmount,
                      ',',
                      '.'
                    )
                  : '0'
              }}
              {{ selectedInvoiceList.currencyName }}
            </div>
          </div>
        </div>
        <div class="mt-4 text-center">
          <button class="btn btn-sm btn-danger" @click="payAndConfirmSessions">
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-bag-check"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
              ></path>
            </svg>
            پرداخت و ثبت
          </button>
        </div>
      </div>
      <div v-else>
        <p class="mb-2" style="text-align: justify">
          صورت وضعیت شما با موفقیت پرداخت شد و جلسات مورد نظر شما در لیست جلسات
          قرار گرفت.
        </p>
        <hr class="m-2" />
        <div class="mt-4 text-center">
          <button class="btn btn-sm btn-blueSite" @click="gotItResult">
            <svg
              class="float-start"
              width="18px"
              height="18px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
              ></path>
              <path
                fill-rule="evenodd"
                d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
            </svg>
            لیست جلسات
          </button>
        </div>
      </div>
    </template>
  </site-modal>
  <div v-if="clientHasInvoice && invoiceList.length != 0">
    <div class="m-2 mt-3">
      <p>
        <i class="fi fi-round-info-full text-danger-gradient blinkText"></i>
        در صورت عدم تسویه صورتحساب، جلسات انتخابی شما پس از 20 دقیقه به صورت
        خودکار لغو می شوند
      </p>
    </div>
    <div
      v-for="invoice in invoiceList"
      :key="invoice.id"
      :style="!isMobile ? 'max-height: 70vh; overflow: auto' : ''"
    >
      <div class="card border-secondary text-dark m-2">
        <h5 class="card-header bg-lightsecondary">
          <div class="d-flex justify-content-between">
            <div :class="isMobile ? 'fs-7' : ''">
              <b>شماره صورت حساب:</b>
              <small class="me-1">
                {{ invoice.invoiceCode }}
              </small>
            </div>
            <div></div>
          </div>
        </h5>
        <div class="card-body p-0">
          <div class="row m-auto text-right p-3">
            <div class="col-md-5 col-6">
              <h6 :class="isMobile ? 'fs-8' : ''">
                نوع ارز: <b>{{ invoice.currencyName }}</b>
              </h6>
              <h6 :class="isMobile ? 'fs-8' : ''">
                وضعیت:
                <b>{{ invoice.invoiceStatusTypeTitle }}</b>
              </h6>
            </div>
            <div class="col-md-5 col-6">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تعداد جلسات:
                <b v-if="loadComplete">{{ getInvoiceCount(invoice) }}</b>
              </h6>
              <h6 :class="isMobile ? 'fs-8' : ''">
                مبلغ کل:
                <b
                  >{{ thousandSeprator(invoice.totalAmount, ',', '.') }}
                  {{ invoice.currencyName }}</b
                >
              </h6>
            </div>
            <div class="col-md-5 col-12">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تاریخ صورت حساب:
                <b>
                  {{ getPersianDate(invoice.invoiceDateTime) }}
                </b>
              </h6>
            </div>
            <div class="col-md-5 col-12" v-if="isOverseas()">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تاریخ صورت حساب(میلادی):
                <b class="gregorianDateClass" style="unicode-bidi: isolate">
                  {{ getGregorianDateOfSession(invoice.invoiceDateTime) }}
                </b>
              </h6>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-sm btn-danger text-white w-100"
                @click="showPaySessionsModal(invoice)"
                :class="isMobile ? 'p-1 fs-7' : ''"
              >
                آماده پرداخت
              </button>
            </div>
          </div>
          <div class="card">
            <div
              class="card-header border-0 p-0 border bg-transparent"
              id="cleanHeadingBorder5"
            >
              <h4 class="mb-0">
                <button
                  class="btn bg-gray-200 shadow w-100 btn-lg text-align-center text-decoration-none text-blueSite collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#shadowCollapse`"
                  aria-expanded="false"
                  aria-controls="shadowCollapse"
                  :class="isMobile ? 'fs-8' : ''"
                >
                  جزئیات صورت حساب
                  <span class="group-icon me-2">
                    <i class="fi fi-arrow-down-slim"></i>
                    <i class="fi fi-arrow-up-slim"></i>
                  </span>
                </button>
              </h4>
            </div>
            <div
              :id="`shadowCollapse`"
              class="collapse mt-1 scrollable-styled-dark show"
              :style="!isMobile ? 'max-height: 30vh; overflow: auto' : ''"
              aria-labelledby="cleanHeadingBorder"
              data-bs-parent="#accordionBottomBorder"
            >
              <div
                v-for="(invoiceItem, index) in invoice.invoiceItems"
                :key="invoiceItem.id"
                class="card border-secondary text-dark m-2"
              >
                <h5
                  class="card-header p-1 px-2"
                  :class="
                    invoiceItem.relatedSessionCancled
                      ? 'bg-danger-soft'
                      : 'bg-gray-300'
                  "
                >
                  <div class="d-flex justify-content-between">
                    <div :class="isMobile ? 'fs-7' : ''">
                      #{{ index + 1 }}
                      {{ invoiceItem.relatedSessionCancled ? '(لغو شده)' : '' }}
                    </div>
                    <div :class="isMobile ? 'fs-8' : ''">
                      <!-- <div
                        class="text-danger"
                        v-if="
                          !invoiceItem.relatedSessionCancled &&
                          !invoiceItem.isCancelable
                        "
                      >
                        غیر قابل لغو
                      </div> -->

                      <button
                        v-if="
                          !invoiceItem.relatedSessionCancled &&
                          invoiceItem.isCancelable
                        "
                        class="btn btn-sm btn-outline-danger ms-2 p-1 px-2"
                        @click="showDeleteConfirmation(invoiceItem.sessionID)"
                        :class="isMobile ? 'p-1 fs-7' : ''"
                      >
                        <svg
                          width="16px"
                          height="16px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                          ></path>
                        </svg>
                        لغو
                      </button>
                    </div>
                  </div>
                </h5>
                <div class="card-body">
                  <div class="row m-auto text-right">
                    <div class="col-md-3 col-6">
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        از ساعت:
                        <b>{{ getHourAndMinute(invoiceItem.fromTime) }}</b>
                      </h6>
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        تا ساعت:
                        <b>{{ getHourAndMinute(invoiceItem.toTime) }}</b>
                      </h6>
                    </div>
                    <div class="col-md-3 col-6">
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        نوع جلسه:
                        <b>{{ invoiceItem.sessionType }}</b>
                      </h6>
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        درمانگر:
                        <b>{{ invoiceItem.therapist }}</b>
                      </h6>
                    </div>
                    <div class="col-md-3 col-7">
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        نوع جلسه درمان:
                        <b>{{ invoiceItem.therapyType }}</b>
                      </h6>
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        تعرفه:
                        <b>{{ invoiceItem.tariffType }}</b>
                      </h6>
                    </div>
                    <div
                      class="col-md-3"
                      v-if="invoiceItem.therapyTypeID == 14"
                    >
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        نام تست:
                        <b>{{ getTestName }}</b>
                      </h6>
                    </div>
                    <div class="col-md-6 col-12">
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        تاریخ جلسه:
                        <b>
                          {{ getPersianDate(invoiceItem.sessionDate) }}
                        </b>
                      </h6>
                    </div>
                    <div class="col-md-6 col-12" v-if="isOverseas()">
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        تاریخ جلسه(میلادی):
                        <b
                          class="gregorianDateClass"
                          style="unicode-bidi: isolate"
                        >
                          ({{
                            getGregorianDateOfSession(invoiceItem.sessionDate)
                          }})
                        </b>
                      </h6>
                    </div>
                    <div class="col-md-12">
                      <h6
                        v-if="!invoiceItem.isCancelable"
                        :class="isMobile ? 'fs-8' : ''"
                      >
                        جلسه قابل لغو:
                        <b
                          :class="
                            invoiceItem.isCancelable
                              ? 'text-success'
                              : 'text-danger'
                          "
                        >
                          <i
                            class="fi mdi-check"
                            v-if="invoiceItem.isCancelable"
                          ></i>
                          <i class="fi mdi-close" v-else></i>
                          {{ invoiceItem.isCancelable ? 'بلی' : 'خیر' }}
                        </b>
                      </h6>
                    </div>

                    <div class="col-md-3 col-12">
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        قیمت:
                        <b
                          >{{
                            thousandSeprator(
                              invoiceItem.totalItemAmount,
                              ',',
                              '.'
                            )
                          }}
                          {{ invoice.currencyName }}
                        </b>
                        <span
                          v-if="invoiceItem.discountCode"
                          class="text-success"
                          >(تخفیف‌دار)</span
                        >
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="m-2 mt-3 text-center" v-if="compeletlyLoad">
      <p>لطفا یکی از گزینه‌های زیر را انتخاب کنید:</p>
      <div class="row g-1">
        <div :class="isMobile ? 'col-6' : 'col-lg-3 col-md-6'">
          <button class="btn btn-sm btn-danger w-100 px-1" @click="goToReserve">
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-clock-history ms-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
              ></path>
              <path
                d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
              ></path>
              <path
                d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
              ></path>
            </svg>
            رواندرمانی و روانپزشکی
          </button>
        </div>
        <div :class="isMobile ? 'col-6' : 'col-lg-3 col-md-6'">
          <button
            class="btn btn-sm testSessionsTheme w-100 px-1"
            @click="goToReserveTest"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-journal-check ms-2"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
              ></path>
              <path
                d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
              ></path>
            </svg>
            تست و ارزیابی
          </button>
        </div>
        <div :class="isMobile ? 'col-6 mt-2' : 'col-lg-3 col-md-6'">
          <button
            class="btn btn-sm btn-success text-white w-100 px-1"
            @click="goToGroupTherapy"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-people mb-1"
              viewBox="0 0 16 16"
            >
              <path
                d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
              ></path>
            </svg>
            گروه درمانی
          </button>
        </div>
        <div :class="isMobile ? 'col-6 mt-2' : 'col-lg-3 col-md-6 px-1'">
          <button
            class="btn btn-sm btn-warning text-secondary w-100"
            @click="goToWorkshop"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-person-workspace mb-1"
              viewBox="0 0 16 16"
            >
              <path
                d="M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H4Zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
              ></path>
              <path
                d="M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.373 5.373 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2H2Z"
              ></path>
            </svg>
            کارگاه آموزشی
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import LoadingSpinner from '../../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import ValidationSummery from '../../../../../components/form/errorBox/ValidationSummery.vue';
import CheckBoxWithMessage from '../../../../../components/form/checkBoxWithMessage/CheckBoxWithMessage.vue';
import { isMobile } from 'mobile-device-detect';
import { Modal } from 'bootstrap';
export default {
  components: {
    LoadingSpinner,
    CheckBoxWithMessage,
    ValidationSummery,
  },
  inject: ['WalletList', 'clearSemiReserveList', 'RefreshWalletList'],
  props: {
    entityObject: {
      therapyTypeID: null,
      scopeIDs: [],
    },
  },
  computed: {
    getTestName() {
      return localStorage.getItem('testName');
    },
  },
  data() {
    return {
      loadComplete: false,
      isMobile: isMobile,
      checkoutInvoiceHasError: false,
      goTosessionsListSuccessfully: false,
      checkoutInvoiceModalError: [],
      useWallet: false,
      deleteConfirmationModal: new Object(),
      paySessionsModal: new Object(),
      clientHasInvoice: true,
      compeletlyLoad: false,
      walletList: [],
      modalError: [],
      invoiceList: new Array(),
      selectedSessionIDToCancel: 0,
      selectedInvoiceList: new Object({
        currencyName: '',
        totalAmount: 0,
        walletBalance: 0,
        invoiceItems: [],
      }),
    };
  },
  methods: {
    getInvoiceCount(invoice) {
      // invoice.invoiceItems.length

      if (!invoice) return 0;
      if (invoice.invoiceItems.length == 0) return 0;
      let total = invoice.invoiceItems.filter(
        (f) => f.relatedSessionCancled == false
      );
      return total.length;
    },
    gotItResult() {
      this.closedPaySessionsModal();
      this.$router.push({
        name: 'sessionsTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    showPaySessionsModal(invoice) {
      this.selectedInvoiceList = invoice;
      this.paySessionsModal.show();
    },
    closedPaySessionsModal() {
      this.paySessionsModal.hide();
      this.useWallet = false;
      this.checkoutInvoiceHasError = false;
      this.checkoutInvoiceModalError = [];
    },
    getClientPhoneEmail() {
      return this.$store.getters.phone ?? this.$store.getters.email ?? '';
    },
    async payAndConfirmSessions() {
      let that = this;

      this.$refs.spinner.show();
      await axios
        .post('/FN/InvoiceHeader/CheckoutInvoiceForSite', {
          invoiceHeaderID: that.selectedInvoiceList.id,
          clientName: that.$store?.getters?.userFullName,
          clientPhoneEmail: that.getClientPhoneEmail(),
          useWalletBalance: that.useWallet,
          description: '',
        })
        .then(async (response) => {
          if (!response.data?.success) {
            that.checkoutInvoiceHasError = true;
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.checkoutInvoiceModalError = errorMessages;
            return;
          }
          //اگر پاسخ حاوی لیینک پرداخت بود، به صفحه پرداخت هدایت شود
          if (response.data.success && response.data.returnValue) {
            window.location.href = response.data.returnValue;
            return;
          }

          that.$refs.notification.show({
            type: 'success',
            title: `صورت حساب شما با موفقیت تسویه شد.`,
          });
          that.goTosessionsListSuccessfully = true;
          that.clearSemiReserveList();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `تسویه صورت حساب جلسات با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    closedDeleteConfirmation() {
      this.deleteConfirmationModal.hide();
    },
    async confirmDeleteInvoice() {
      if (this.selectedSessionIDToCancel == 0) return;
      this.$refs.spinner.show();
      let that = this;
      await axios
        .post(
          '/CLC/Session/CancelSessionForSite',
          new Object({ ID: this.selectedSessionIDToCancel })
        )
        .then((response) => {
          that.$refs.spinner.hide();
          if (!response.data.success) {
            that.modalError = response.data.errors.map((i) => i.errorMessage);
            return;
          }
          that.invoiceList.forEach((inv) => {
            let currentInvoice = inv.invoiceItems.find(
              (item) => item.sessionID == that.selectedSessionIDToCancel
            );
            currentInvoice.relatedSessionCancled = true;

            inv.totalAmount -= currentInvoice.price;
            if (inv.invoiceItems.every((item) => item.relatedSessionCancled)) {
              that.invoiceList = that.invoiceList.filter((item) => {
                return item.id != inv.id;
              });
            }
          });
          that.deleteConfirmationModal.hide();
          that.$refs.notification.show({
            type: 'success',
            title: `جلسه انتخاب شده با موفقیت لغو شد`,
          });
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    showDeleteConfirmation(sessionID) {
      this.selectedSessionIDToCancel = sessionID;
      this.deleteConfirmationModal.show();
    },
    goToReserve() {
      this.clearSemiReserveList();
      this.$router.push({
        name: 'selectTherapist',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    goToReserveTest() {
      this.clearSemiReserveList();
      this.$router.push({
        name: 'selectTestSession',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    goToWorkshop() {
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 2 },
      });
    },
    goToGroupTherapy() {
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 1 },
      });
    },
    getHourAndMinute(data) {
      return `${data.split(':')[0]}:${data.split(':')[1]}`;
    },
    getPersianDate(date) {
      // eslint-disable-next-line
      return new persianDate(new Date(date)).format('L');
    },
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
    thousandSeprator(number, seprator, decimalPointer) {
      // eslint-disable-next-line
      return thousandSeprator(number, seprator, decimalPointer);
    },
  },
  async mounted() {
    let that = this;
    await this.RefreshWalletList();
    that.walletList = that.WalletList();

    that.$refs.spinner.show();
    await axios
      .get(
        `/FN/InvoiceHeader/GetAllInvoicesForCheckout?personID=${that.$store.getters.userPersonID}`
      )
      .then((response) => {
        if (response.data == '') that.clientHasInvoice = false;

        if (response.data.length != 0) {
          if (that.walletList.length == 0) return;
          if (
            that.walletList.find(
              (f) => f.currencyTypeID == response.data[0].currencyTypeID
            ).balance != 0
          )
            that.useWallet = true;
          that.invoiceList = response.data;
          that.invoiceList.forEach((inv) => {
            if (inv.invoiceItems.every((item) => item.relatedSessionCancled)) {
              that.invoiceList = that.invoiceList.filter((item) => {
                return item.id != inv.id;
              });
            }
          });
          that.loadComplete = true;
        }
      })
      .catch(() => {
        this.$refs.notification.show({
          type: 'error',
          title: `عملیات دریافت صورت حساب شما با خطا مواجه گردید..`,
        });
      })
      .finally(() => {
        that.$refs.spinner.hide();
      });

    this.deleteConfirmationModal = new Modal(
      document.getElementById('deleteConfirmation'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.paySessionsModal = new Modal(
      document.getElementById('paySessionsModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.compeletlyLoad = true;
  },
};
</script>
<style scoped>
.headerResult {
  background-color: #4c5e74;
  color: white;
  border-radius: 10px 10px 0px 0px;
  padding: 10px;
}
</style>
